<template>
  <div>
    <div
      v-if="surveyRow.question != undefined"
      style="
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-auto-rows: minmax(100px, auto);
        border-top: 1px solid;
        padding-top: 10px;
      "
    >
      <div
        style="
          display: grid;
          grid-column: 1;
          grid-row: 1 / 2;

          align-items: center;
        "
      >
        <p>
          {{ surveyRow.question }}
        </p>
      </div>
      <div>
        <div style="display: grid; grid-column: 2; grid-row: 1">
          <div class="level">
            <div class="level-item" style="width: 25%">
              A: {{ surveyRow.keywordMin }}
            </div>
            <div class="level-item" style="width: 25%; display: block">
              <span class="arrow-left"></span>
            </div>
            <div class="level-item" style="width: 25%; display: block">
              <span class="arrow-right"></span>
            </div>

            <div class="level-item" style="width: 25%">
              B: {{ surveyRow.keywordMax }}
            </div>
          </div>
        </div>
        <div
          style="
            display: grid;
            grid-column: 2;
            grid-row: 2;
            grid-auto-flow: column;
            align-items: center;
            justify-items: center;
            margin-top: 10px;
          "
        >
          <b-radio
            v-model="answer"
            v-for="answerValue in surveyRow.range"
            :key="answerValue"
            :name="surveyRow.order.toString()"
            @input="onRdoChanged"
            :native-value="answerValue"
            >{{ answerValue }}
          </b-radio>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        style="
          border-top: 1px solid;
          padding-top: 10px;
          padding-bottom: 2em;
          margin-left: 15%;
          margin-right: 15%;
        "
      >
        <div>
          <div style="display: grid; grid-column: 2; grid-row: 1">
            <div class="level">
              <div class="level-item" style="width: 25%">
                A: {{ surveyRow.keywordMin }}
              </div>
              <div class="level-item" style="width: 25%; display: block">
                <span class="arrow-left"></span>
              </div>
              <div class="level-item" style="width: 25%; display: block">
                <span class="arrow-right"></span>
              </div>

              <div class="level-item" style="width: 25%">
                B: {{ surveyRow.keywordMax }}
              </div>
            </div>
          </div>
          <div
            style="
              display: grid;
              grid-column: 2;
              grid-row: 2;
              grid-auto-flow: column;
              align-items: center;
              justify-items: center;
              margin-top: 10px;
            "
          >
            <b-radio
              v-model="answer"
              v-for="answerValue in surveyRow.range"
              :key="answerValue"
              :name="surveyRow.order.toString()"
              @input="onRdoChanged"
              :native-value="answerValue"
              >{{ answerValue }}
            </b-radio>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      answer: "-1",
    };
  },
  props: {
    surveyRow: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onRdoChanged() {
      this.$store.dispatch("survey/addAnswer", {
        order: this.surveyRow.order,
        answer: this.answer,
        value: this.surveyRow.value,
        factor: this.surveyRow.factor,
      });
    },
  },
};
</script>

<style lang="css" scoped>
.field-label {
  width: 50vw;
}
.field-body {
  width: 50vw;
}

.arrow-right:after {
  content: "";
  display: inline-block !important;
  width: 0;
  height: 0;
  border-left: 8px solid #005960;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  vertical-align: middle;
}

.arrow-right:before {
  width: 80%;
  height: 2px;
  background: linear-gradient(to right, #ccc 0%, #005960 90%);
  content: "";
  display: inline-block;
  vertical-align: middle;
}

.arrow-left::before {
  content: "";
  display: inline-block !important;
  width: 0;
  height: 0;
  border-right: 8px solid #005960;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  vertical-align: middle;
}

.arrow-left:after {
  width: 80%;
  height: 2px;
  background: linear-gradient(to left, #ccc 0%, #005960 90%);
  content: "";
  display: inline-block;
  vertical-align: middle;
}
/*
.arrow-right::after {
  content: "\2192";
  font-size: 2em;
  padding: 0 0.5em;
  vertical-align: -0.1em;
  align-content: stretch;
}
.arrow-left::after {
  content: "\2190";
  font-size: 2em;
  padding: 0 0.5em;
  vertical-align: -0.1em;
}*/
</style>
